import { Component,OnInit} from '@angular/core';
import { NavController } from 'ionic-angular';
import {MydataService} from './mydata.service';
import {} from 'jasmine';
import {MyUrlService} from './checkUrll';
import {MyvariableService} from './constantvariable';
import {JsonData} from './dataaa';
import  { Http } from '@angular/http';
import {KiloMenuPage} from "../kilomenu/kilomenu";
import {KiloPartyPage} from "../kiloparty/kiloparty";
import {KiloStorePage} from "../kilostore/kilostore";
import {LoginPage} from "../login/login";
import {MycartPage}  from '../mycart/mycart';
import {OrderHistoryPage}  from '../orderhistory/orderhistory';
import {ReferFriendsPage}  from '../referfriends/referfriends';
import {KiloPointsPage}  from '../kilopoints/kilopoints';
import {AboutUsPage}  from '../aboutus/aboutus';
import {ProfilePage} from '../profile/profile';
import {SignUpPage}  from '../signup/signup';
import {InfoPage}  from '../info/info';
import { LoadingController } from 'ionic-angular';
import { Contacts, Contact, ContactField, ContactName } from '@ionic-native/contacts';
import {GooglePlaceModule} from "angular2-google-place"


//import {EventModel} from '../../models/EventModel';
//import {Router, ROUTER_DIRECTIVES, ROUTER_PROVIDERS, RouteConfig, RouteParams, RouterLink} from 'angular2/router';

//import {LoginPage} from "../login/login";
//import {SignUpPage} from "../signup/signup";
//import { HomePage } from "home/home";

@Component({
	selector: 'page-home',
	templateUrl: 'home.html',
	
	providers:[MydataService,MyUrlService,JsonData,MyvariableService,Contacts]
})
export class HomePage implements OnInit {
	jsonDt : Array<JsonData>;
	categoryDt: Array<JsonData>;
	userDt: Array<JsonData>;
	userids: Array<JsonData>;
	//totalcounts:Array<JsonData>;
	allContacts:Array<any>;
	displayContact:any;
	//postData:[];
	sessionn:any;
	
	//keys :string;
	
	constructor(private contacts: Contacts, private http:Http,public loading: LoadingController,public navCtrl: NavController,private mydataService: MydataService,private myurlService: MyUrlService,private MyvariableService: MyvariableService) {
		
	}
	
	kilomenu(cartid,subcat)
	{
		window.localStorage.setItem('localid', cartid );
		window.localStorage.setItem('subcatid', subcat );
		//var xyz = window.localStorage.getItem('localid');
		
		//alert(cartid)
		if(cartid==1)
		{
			//this.navCtrl.push(KiloMenuPage);
			this.navCtrl.setRoot(KiloMenuPage);
		}
		if(cartid==2)
		{
			//this.navCtrl.push(KiloPartyPage);
			this.navCtrl.setRoot(KiloPartyPage);
		}
		if(cartid==3)
		{
			//this.navCtrl.push(KiloStorePage);
			this.navCtrl.setRoot(KiloStorePage);
		}
		
	}
	homeLogin()
	{
		this.navCtrl.push(LoginPage);
	}
	
	ngOnInit() {
		
		this.mydataService.navigationRef();
		
		
		if(this.mydataService.checkInternetFunction()=="0"){
			////////console.log("Internet UnAvailable")
			}else  if(this.mydataService.checkInternetFunction()=="1"){
			var userid = window.localStorage.getItem('userid');
			//alert(userid);
			let loader = this.loading.create({content: '',});
			var session_ids=window.localStorage.getItem('session_ids');
			var kiloSabjiJSONdata = JSON.stringify({"userid":userid,"IMEI":session_ids});
			
			////////console.log("Home Url--->"+this.myurlService.HOMEURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.HOMEURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.homeService(loader));
			});
		}	}
		
		errorFunction= function(loader,error){
			loader.dismiss();
			//////console.log(error);
			//alert(error);
		}
		
		
		homeService=function(loader){
			////////console.log(" Home Receive jsondata ==>"+JSON.stringify(this.jsonDt.categorydata));
			////////console.log("namedata ==>"+JSON.stringify(this.jsonDt.userdata));
			////////console.log("category dt =====>"+JSON.stringify(this.jsonDt));
			
			this.totalcounts=this.jsonDt.totalcount;
			//alert(JSON.stringify(this.totalcounts));
			
			this.categoryDt = this.jsonDt.categorydata;
			this.userDt = this.jsonDt.userdata;
			this.kilopointdataDt = this.jsonDt.kilopointdata;
			this.orderconfigDt = this.jsonDt.orderconfig;
			this.subcategoryDt = this.jsonDt.subcategory;
			this.sessionstoreDt = this.jsonDt.sessionstore;
			this.description_kilomenu = this.categoryDt[0].description;
			this.description_kiloparty = this.categoryDt[1].description;
			this.description_kilostore = this.categoryDt[2].description;
			
			this.balances = this.kilopointdataDt[0].balance;
			this.deliveryTime = this.orderconfigDt[0].deliveryTime;
			window.localStorage.setItem('deliverytimes', this.deliveryTime );
			this.userids=window.localStorage.getItem('userid');
			this.signupPoint = this.jsonDt.orderconfig[0].signupPoint;
			this.takeawayDiscount = this.jsonDt.orderconfig[0].takeawayDiscount;
			this.referFriendPoint = this.jsonDt.orderconfig[0].referFriendPoint; 
			this.sessionid = this.sessionstoreDt[0].sessionid;
			window.localStorage.setItem('description_kilomenus',this.description_kilomenu);
			window.localStorage.setItem('description_kilopartys',this.description_kiloparty);
			window.localStorage.setItem('description_kilostores',this.description_kilostore);			 
			
			window.localStorage.setItem('referFriendPoints',this.referFriendPoint);
			window.localStorage.setItem('signupPoints',this.signupPoint);
			window.localStorage.setItem('takeawayDiscounts',this.takeawayDiscount);
			
			this.session_ids=window.localStorage.getItem('session_ids');
			
			if(this.session_ids==null){
				window.localStorage.setItem('session_ids', this.sessionid );
			}
			this.session_ids=window.localStorage.getItem('session_ids');
			//alert(this.description_kilomenu);
			
			
			if(this.userids==null){
				this.useriddata='null';
			}else{this.useriddata=this.userids;}
			this.homevalue= this.MyvariableService.HOMEVALUE;
			this.image= this.myurlService.IMAGEURL;
		window.localStorage.setItem('session_ids', this.sessionid );
		loader.dismiss();
		//alert(this.useriddata);
		//alert("dfgdffgdg");
		////////console.log("category dt =====>"+this.categoryDt[0].id);
		////////console.log("category dt =====>"+this.categoryDt[0].description);
		////////console.log("category dt =====>"+this.categoryDt[0].orgId);
		
		////////console.log("image ==>"+this.userDt[0].name);
		
		
		
		////////console.log("categorydata ==>"+JSON.stringify(this.jsonDt.categorydata));
		
		////////console.log("mobilenodata ==>"+JSON.stringify(this.jsonDt.mobilenodata));
		//	//////console.log("func post ---->"+this.postData);
		
		/*this.allContacts= window.localStorage.getItem("allContacts");
		if(this.allContacts!=null){
		for(var i=0;i<this.allContacts.length;i++){
		this.displayContact=this.allContacts[i]._objectInstance;
		//if(window.localStorage.getItem(this.displayContact.displayName)!=null){
		window.localStorage.removeItem(this.displayContact.phoneNumbers[0].value);
		if(window.localStorage.removeItem(this.displayContact.phoneNumbers[0].value)!=null){
		alert("Contact Number===>"+JSON.stringify(this.displayContact.displayName));
		}
		//}
		}
		}*/
		
		}
		
		
		headermemu(pageget)
		{
		
		if(pageget=='HomePage'){
		this.navCtrl.setRoot(HomePage);
		}
		if(pageget=='MycartPage'){
		this.navCtrl.setRoot(MycartPage);
		}
		if(pageget=='AboutUsPage'){
		this.navCtrl.setRoot(AboutUsPage);
		}
		
		if(pageget=='OrderHistoryPage'){
		this.navCtrl.setRoot(OrderHistoryPage);
		}
		if(pageget=='ProfilePage'){
		this.navCtrl.setRoot(ProfilePage);
		}
		if(pageget=='LoginPage'){
		this.navCtrl.setRoot(LoginPage);
		}
		if(pageget=='SignUpPage'){
		this.navCtrl.setRoot(SignUpPage);
		}
		if(pageget=='InfoPage'){
		this.navCtrl.setRoot(InfoPage);
		
		}
		if(pageget=='logout'){
		window.localStorage.clear();
		//this.userids=window.localStorage.getItem('userid');
		//alert(this.userids);
		this.navCtrl.setRoot(HomePage);
		}
		
		
		}
		
		/* homehead()
		{
		this.navCtrl.setRoot(HomePage);
		}
		kilomenuhead(cartid)
		{
		window.localStorage.setItem('localid', cartid );
		this.navCtrl.setRoot(KiloMenuPage);
		}
		kilopartyhead(cartid)
		{
		window.localStorage.setItem('localid', cartid );
		this.navCtrl.setRoot(KiloPartyPage);
		}
		kilostorehead(cartid)
		{
		window.localStorage.setItem('localid', cartid );
		this.navCtrl.setRoot(KiloStorePage);
		}
		mycarthead()
		{
		
		this.navCtrl.setRoot(MycartPage);
		}
		abouthead()
		{
		
		this.navCtrl.setRoot(AboutUsPage);
		}
		orderhead()
		{
		
		this.navCtrl.setRoot(OrderHistoryPage);
		}
		referhead()
		{
		
		this.navCtrl.setRoot(ReferFriendsPage);
		}
		kilopointshead()
		{
		
		this.navCtrl.setRoot(KiloPointsPage);
		}
		profilehead()
		{
		
		this.navCtrl.setRoot(ProfilePage);
		}
		loginhead()
		{
		
		this.navCtrl.setRoot(LoginPage);
		}
		signuphead()
		{
		
		this.navCtrl.setRoot(SignUpPage);
		}
		logouthead()
		{
		window.localStorage.clear();
		//this.userids=window.localStorage.getItem('userid');
		//alert(this.userids);
		this.navCtrl.setRoot(HomePage);
		}
		*/
		}
		
		
		
		
		
		
		
		
		
		
		
				


// WEBPACK FOOTER //
// ./src/pages/home/home.ts